import { useEffect } from 'react';
import { CardButtonsContainer } from 'src/components/CardButton';
import { ReactComponent as AKSLogo } from 'src/assets/icons/AKS.svg';
import { ReactComponent as InfraLogo } from 'src/assets/icons/infraspecific.svg';
import { ReactComponent as AuditLogo } from 'src/assets/icons/audit.svg';
// import { ReactComponent as ObservabilityLogo } from 'src/assets/icons/observabilityMonitor.svg';
import { ReactComponent as SolutionLogo } from 'src/assets/icons/solutions .svg';
import { useStoreUnitActions } from 'src/redux/helpers';
import PageCardLayout, { PageCardLoader } from 'src/components/PageCardLayout';
import monitoringStore, { useMonitoringUrlList } from '../redux';
import MonitoringCardButton from './MonitoringCardButton';

function MonitorDashboards() {
  const actions = useStoreUnitActions(monitoringStore);
  const [data, loading] = useMonitoringUrlList();

  useEffect(() => {
    actions.monitoringUrlList();
  }, []);

  return (
    <PageCardLayout title="Monitoring">
      <CardButtonsContainer>
        <MonitoringCardButton
          title="AKS Dashboard"
          Icon={AKSLogo}
          onClick={() => window.open(data?.aksDashboardUrl)}
          disabled={
            data?.aksDashboardUrl === '' || data?.aksDashboardUrl === undefined
          }
        />
        <MonitoringCardButton
          title="Solution Specific Workload"
          Icon={SolutionLogo}
          onClick={() => window.open(data?.solutionSpecificWorkloadUrl)}
          disabled={
            data?.solutionSpecificWorkloadUrl === '' ||
            data?.solutionSpecificWorkloadUrl === undefined
          }
        />
        <MonitoringCardButton
          title="Infra Specific Workload Dashboard"
          Icon={InfraLogo}
          onClick={() => window.open(data?.infraSpecificWorkloadUrl)}
          disabled={
            data?.infraSpecificWorkloadUrl === '' ||
            data?.infraSpecificWorkloadUrl === undefined
          }
        />
        <MonitoringCardButton
          title="Audit logs"
          Icon={AuditLogo}
          onClick={() => window.open(data?.auditLogUrl)}
          disabled={data?.auditLogUrl === '' || data?.auditLogUrl === undefined}
        />
        <MonitoringCardButton
          title="Application logs"
          Icon={AKSLogo}
          onClick={() => window.open(data?.microservicesLogsDashboardUrl)}
          disabled={
            data?.microservicesLogsDashboardUrl === '' ||
            data?.microservicesLogsDashboardUrl === undefined
          }
        />
      </CardButtonsContainer>
      {loading && <PageCardLoader />}
    </PageCardLayout>
  );
}

export default MonitorDashboards;
